import _ from 'lodash'

export const omitUndefined = <T extends Record<string, any>>(obj: T): Partial<T> => _.omitBy<T>(obj, _.isUndefined)
